import React, { useState, useEffect } from 'react';
import SVG from 'react-inlinesvg';
import { useLabels, useRequestData } from 'wsm-common-data';
import { isBrowser } from 'ws-scripts/modules/environment';
import { useSelector } from 'react-redux';
import { setClassNames } from 'ddc-classnames-js';
import { getSpotIconSize } from '../../utilities/layout';
import { checkAvailableLeadFormPath } from '../../utilities/leadFormPath';

const NoImage = () => {
	const { deviceType } = useRequestData();
	const spotIconSize = getSpotIconSize(deviceType);
	const { vehicle, pathParameters } = useSelector((state) => state.widgetInfo);
	const labels = useLabels();
	const [leadFormPath, setLeadFormPath] = useState('/lead-form.htm');

	const vehicleId = pathParameters?.vehicleId;

	// Check which lead form path is available (due to site-specific DVS/MongoDB configurations - https://ghe.coxautoinc.com/DDC-WebPlatform/cms-web/blob/master/htdocs/v9/documentation/third-party/service-config/v1/documentation.md)
	useEffect(() => {
		if (!isBrowser || !vehicleId) return;

		const detectLeadFormPath = async () => {
			const pathsToCheck = [
				'/lead-form.htm',
				'/vehiclelead-form.htm'
			];

			const availablePath = await checkAvailableLeadFormPath(pathsToCheck);
			if (availablePath) {
				setLeadFormPath(availablePath);
			}
		};

		detectLeadFormPath();
	}, [vehicleId]);

	const dealerShipName =
		(isBrowser && window.DDC?.dataLayer?.dealership?.dealershipName) || '';
	const vehicleTitle = `${vehicle.make} ${vehicle.model} ${vehicle.trim}`;
	const noImageDescription = labels
		.get('VEHICLE_GALLERY_NO_IMAGE_DESCRIPTION')
		.replace('{vehicleTitle}', vehicleTitle)
		.replace('{dealershipName}', dealerShipName);

	return (
		<div
			data-testid="no-image-message"
			className={setClassNames([
				'bg-contrast-med',
				'border-radius-md',
				'd-flex',
				'align-items-start',
				'px-5',
				'py-5'
			])}
		>
			<div className="mr-4">
				<SVG
					src="/static/assets/icons/spot/camera.svg"
					aria-hidden="true"
					className="ddc-icon-size-xlarge"
					height={spotIconSize}
					width={spotIconSize}
					opacity="0.8"
					loader={
						<div
							style={{
								width: `${spotIconSize}px`,
								height: `${spotIconSize}px`
							}}
						/>
					}
				/>
			</div>
			<div>
				<strong>{labels.get('VEHICLE_GALLERY_NO_IMAGE_TITLE')}</strong>
				<p>{noImageDescription}</p>
				<a
					type="button"
					className="text-link text-link-muted text-decoration-underline dialog"
					href={`${leadFormPath}?vehicleId=${vehicleId}`} 
					target="dialog" 
					data-title={labels.get('VEHICLE_GALLERY_NO_IMAGE_REQUEST_PHOTO_LINK')}
					data-width="375" 
					ui-tabs-initial-load="false"
				>
					{labels.get('VEHICLE_GALLERY_NO_IMAGE_REQUEST_PHOTO_LINK')}
				</a>
			</div>
		</div>
	);
};

export default NoImage;
